import {Avatar} from "components";
import {Connector} from "components/historyTree/connector.tsx";
import {Document, Edit, Link, Plus} from "assets/icons";
import {ActivityLogType, HistoryTreeData, NoteType} from "shared/components/chatter/chatter";


const switchActivityLogType = (type?: ActivityLogType) => {
  switch (type) {
    case ActivityLogType.ADD:
      return <Plus/>;
    case ActivityLogType.EDIT:
      return <Edit/>;
    case ActivityLogType.CONNECT_RESOURCE:
      return <Link/>;
    default:
      return <Document/>
  }
}
export const Node = ({

                       noteType,
                       createdAt,
                       content,
                       activityLogType,
                     }: HistoryTreeData) => {
  return (
    <div className="flex gap-5 min-h-26.5">
      <div className="relative">
        <Avatar icon={switchActivityLogType(activityLogType)}/>
        <Connector/>
      </div>
      <div className="flex flex-col gap-3">
        <div className={noteType === NoteType.MESSAGE ? 'bg-white p-4 rounded-md shadow' : ''}>
          <p className="text-neutral-primary">{content}</p>
          <p className="text-neutral-primary opacity-60">{createdAt.toString()}</p>
        </div>
        <div className="flex gap-3">
          {/*{primaryButtonText &&*/}
          {/*  <Button radius="full" startContent={primaryIcon}*/}
          {/*          className="bg-moss-primary text-white">{primaryButtonText || <Eye />}</Button>}*/}
          {/*{secondaryButtonText &&*/}
          {/*  <Button radius="full" variant="bordered" endContent={secondaryIcon || <ChevronRight />}*/}
          {/*          className="bg-white text-moss-primary border-moss-primary">{secondaryButtonText}</Button>}*/}
        </div>
      </div>
    </div>
  );
};